import React, { useMemo } from 'react';

import { useStyles } from './style';
import { PaymentMethod } from '../../../../../api/payment-method/types';
import { Box, Card, CardContent, Chip, Typography } from '@material-ui/core';
import { useDeletePaymentMethodMutation, useSetDefaultPaymentMethodMutation } from '../../../../../api/payment-method';
import { ToastService } from '../../../../../shared/services/toastService';

interface Props {
  paymentItem: PaymentMethod;
  backStep: () => void;
}

export const PaymentMethodDetail: React.FC<Props> = ({ paymentItem, backStep }) => {
  const classes = useStyles();
  const [setDefaultPaymentMethod] = useSetDefaultPaymentMethodMutation();
  const [deletePaymentMethod] = useDeletePaymentMethodMutation();
  
  const onSetDefaultClick = () => {
    setDefaultPaymentMethod({
      payment_method: paymentItem.id,
    }).then((res) => {
      if ('data' in res && res.data?.success) {
        ToastService.success('Default payment method set successfully');
      } else {
        ToastService.error('Failed to set default payment method');
      }
    });
    backStep();
  };

  const onRemoveCardClick = () => {
    deletePaymentMethod({
      payment_method: paymentItem.id,
    }).then((res) => {
      if ('data' in res && res.data?.success) {
        ToastService.success('Remove payment method successfully');
      } else {
        ToastService.error('Failed to remove payment method');
      }
    });
    backStep();
  };

  const isDefault = useMemo(() => {
    return paymentItem.default;
  }, [paymentItem]);

  const isExpiredCard = useMemo(() => {  
    const expMonth = paymentItem.exp_month;
    const expYear = paymentItem.exp_year;
    if (isNaN(expMonth) || isNaN(expYear)) return true; // invalid format = treat as expired
  
    // Set to the 1st of the next expMonth (so "4/2025" expires on May 1st)
    const expiryDate = new Date(expYear, expMonth);
    const now = new Date();
  
    return expiryDate <= now;
  }, [paymentItem]);

  return (
    <>
      {isExpiredCard && <Box className={classes.expiredCardText}>
        Your card has expired. Please use another card for payment
      </Box>}
      <Card className={classes.card}>  
        <CardContent>
          <Box>
            <Typography className={classes.cardFeatureTitle}>
              <span className={classes.title}>Payment Method</span> {
                isDefault
                  ? <Chip label="DEFAULT" className={classes.defaultChip} />
                  : !isExpiredCard && <span className={classes.setDefaultText} onClick={onSetDefaultClick}>
                      Set Default Method
                    </span>
              }
            </Typography>
            <Box>
              <Typography>
                {paymentItem.display_brand.toUpperCase()} **** **** **** {paymentItem.last4}
              </Typography>

              <Typography>
                Expiry Date: {paymentItem.exp_month}/{paymentItem.exp_year}
              </Typography>

              <Typography>
                CVC: ***
              </Typography>
            </Box>

            {!isDefault && <Box className={classes.removeCard} onClick={onRemoveCardClick}>
              Remove Card
            </Box>}
          </Box>
          
        </CardContent>
      </Card>
    </>
  );
};